module.exports = __webpack_public_path__ + "static/feature_card_desktop113021-4eec3e943c7f80dd7d21d929e354fe74.png";